import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AddMessagePayload } from '../../../support';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export function useReplyToTicket() {
	const queryClient = useQueryClient();
	return useMutation<null, Error, AddMessagePayload>({
		mutationFn: async ({ message, ticketId }) => {
			try {
				await api.post(`/support-tickets/createMessage/${ticketId}`, {
					message,
				});
				return null;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar propriedade');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['support', 'tickets'] });
		},
		onError: (error) => {
			console.error(
				'Erro ao criar mensagem de suporte:',
				getApiErrorMessage(error, 'Erro ao criar mensagem de suporte')
			);
		},
	});
}
